<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  mounted() {
    let scr = document.createElement("script");
    scr.setAttribute("src", "/dashboard-assets/js/pace.min.js");
    scr.defer = true;
    document.head.appendChild(scr);
  }
};
</script>

<style lang="scss" scoped>
// Bootstrap core CSS
@import "../../../public/dashboard-assets/css/bootstrap.min.css";
@import "../../../public/dashboard-assets/css/bootstrap-reset.css";

// // Animation cs
@import "../../../public/dashboard-assets/css/animate.css";

// // Icon-fonts cs
@import "../../../public/dashboard-assets/assets/font-awesome/css/font-awesome.css";

// // Custom styles for this template
@import "../../../public/dashboard-assets/css/style.css";
@import "../../../public/dashboard-assets/css/helper.css";
@import "../../../public/dashboard-assets/css/style-responsive.css";
</style>
